import { ReactNode } from 'react'

import { styled } from '@mui/material'

const Div = styled('div')`
  display: inline-flex;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  min-width: 170px;
  height: 93px;
  margin: 0 10px 10px 0;
  padding: 16px;
  border-radius: 12px;
  vertical-align: top;
  background-color: #f3f3f3; /* TODO: 替换为 theme 里面的 palette */
  cursor: auto;
  user-select: none;
  transition: color 0.2s ease, background-color 0.2s ease;
`

const SelectableDiv = styled(Div)`
  cursor: pointer;
  &:hover {
    color: #3d3d3d; /* TODO: 替换为 theme 里面的 palette，原始项目里的 $black-light */
    background-color: #bdbdbd; /* TODO: 替换为 theme 里面的 $grey-lighter */
  }
  &.active {
    color: #3d3d3d; /* TODO: 替换为 theme 里面的 palette，原始项目里的 $black-light */
    background-color: #bdbdbd; /* TODO: 替换为 theme 里面的 $grey-lighter */
  }
`

const Title = styled('div')`
  font-size: 16px;
  line-height: 1.375em;
  white-space: nowrap;
  color: #3d3d3d; /* TODO: 替换为 theme 里面的 palette，原始项目里的 $black-light */
`

const Data = styled('p')`
  font-size: 22px;
  line-height: 1em;
  font-weight: 500;
  white-space: nowrap;
  margin: 0;
  color: #3d3d3d; /* TODO: 替换为 theme 里面的 palette，原始项目里的 $black-light */
`

type DataBlockBaseProps = {
  title: string
  content?: ReactNode
}

type DataBlockProps =
  | (DataBlockBaseProps & {
      selectable?: false
    })
  | (DataBlockBaseProps & {
      selectable: true
      active: boolean
      handleClick: () => void
    })

export const DataBlock = (props: DataBlockProps) => {
  const { title, content, selectable } = props

  if (!selectable) {
    return (
      <Div>
        <Title>{title}</Title>
        <Data>{content}</Data>
      </Div>
    )
  }

  const { active, handleClick } = props

  return (
    <SelectableDiv
      className={active ? 'active' : ''}
      onClick={handleClick}
      style={{ cursor: selectable ? 'pointer' : 'auto' }}
    >
      <Title>{title}</Title>
      <Data>{content}</Data>
    </SelectableDiv>
  )
}
